<template>
	<div class="reset-password">
		<NavBar :registerPage="true" />
		<v-main>
			<v-row justify="center">
				<v-col lg="4" md="5" sm="7">
					<v-card class="mx-auto mt-3">
						<v-card-title class="primary--text" v-translate>Reset Password</v-card-title>
						<v-card-text class="px-8">
							<v-form ref="form" lazy-validation>
								<v-alert v-model="error" color="red lighten-2" class="text-caption" icon="warning">
									<translate>Error.</translate>
								</v-alert>
								<v-alert v-if="success" v-model="success" color="alert" class="text-caption" type="success">
									<translate>Password is changed. You can now login with your new password.</translate>
								</v-alert>
								<template v-else>
									<v-text-field
										v-model="password"
										:label="$gettext('New Password')"
										prepend-inner-icon="mdi-lock"
										filled
										type="password"
										:rules="passwordRules"
										placeholder=" "
									></v-text-field>
									<v-text-field
										v-model="repeatPassword"
										:label="$gettext('Repeat New Password')"
										prepend-inner-icon="mdi-lock"
										filled
										type="password"
										:rules="equalTo"
										placeholder=" "
									></v-text-field>
								</template>
							</v-form>
						</v-card-text>
						<v-divider></v-divider>
						<v-card-actions v-if="!success" class="pa-3">
							<v-spacer></v-spacer>
							<v-btn depressed color="primary" @click="send()" :loading="loading">
								<translate>Save</translate>
							</v-btn>
						</v-card-actions>
					</v-card>
				</v-col>
			</v-row>
		</v-main>
		<Footer :absolute="true" />
	</div>
</template>

<script>
import NavBar from "@/components/authentication/NavBar.vue";
import Footer from "@/components/authentication/Footer.vue";
import axios from "axios";

export default {
	name: "ResetPassword",
	components: {
		NavBar,
		Footer
	},
	data: () => ({
		error: false,
		loading: false,
		password: "",
		repeatPassword: "",
		success: false
	}),
	computed: {
		passwordRules() {
			return [
				v => !!v || this.$gettext("Password is required"),
				v =>
					(v && v.length >= 8) ||
					this.$gettext("Password must have at least 8 characters")
			];
		},
		equalTo() {
			return [
				v => v && v === this.password || this.$gettext("Passwords must match")
			];
		}
	},
	methods: {
		validate() {
			const token = this.$route.query.token;
			const email = this.$route.query.email;
			console.log(email, token);
			return this.$refs.form.validate() && token && email;
		},
		send() {
			if (this.validate()) {
				this.loading = true;
				this.error = false;
				this.success = false;
				const token = this.$route.query.token;
				const email = this.$route.query.email;
				const formData = new FormData();
				formData.append("email", email);
				formData.append("pwd", this.password);
				formData.append("again", this.repeatPassword);
				axios
					.post("/resetpassword/" + token, formData)
					.then(response => {
						console.log(response.data);
						if (response.data.result === "ok") {
							this.success = true;
						} else {
							this.error = true;
						}
						this.loading = false;
					})
					.catch(error => {
						console.log(error);
						this.error = true;
						this.loading = false;
					});
			}
		}
	}
};
</script>